<template>
    <el-dialog title="新增信用卡" :visible.sync="dialogTableVisible" width="30%">
        <el-row class="border-bottom padding">
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">信用卡持有人：</el-col>
                <el-col :span="15">
                    <el-input v-model="ACreditCard.name"></el-input>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">开户银行：</el-col>
                <el-col :span="15">
                    <el-input v-model="ACreditCard.Bank"></el-input>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">信用卡号：</el-col>
                <el-col :span="15">
                    <el-input v-model="ACreditCard.Cardnumber"></el-input>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">账单日：</el-col>
                <el-col :span="15">
                    <el-select v-model="ACreditCard.bill" placeholder="请选择" style="width:100%;">
                        <el-option v-for="item in 31" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">还款日：</el-col>
                <el-col :span="15">
                    <el-select
                        v-model="ACreditCard.repayment"
                        placeholder="请选择"
                        style="width:100%;"
                    >
                        <el-option v-for="item in 31" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
            </el-col>
            <el-col :span="24" class="line-height padding">
                <el-col :span="5">有效日期：</el-col>
                <el-col :span="15">
                    <el-date-picker
                        @change="Time"
                        v-model="ACreditCard.Effective"
                        type="month"
                        placeholder="选择月"
                        style="width:100%;"
                    ></el-date-picker>
                </el-col>
            </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTableVisible = false">取 消</el-button>
            <el-button type="primary" @click="save()">提 交</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../../api/api/api";
export default {
    name: "Addcommodity",
    data() {
        return {
            dialogTableVisible: false,
            ACreditCard: {
                name: "",
                Bank: "",
                Cardnumber: "",
                bill: "",
                repayment: "",
                Effective: ""
            }
        };
    },
    mounted() {},
    created() {},
    methods: {
        init() {
            this.dialogTableVisible = true;
        },
        Time(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1);
            this.ACreditCard.Effective = datetime;
            console.log(this.ACreditCard.Effective);
        },
        save() {
            var role = JSON.parse(window.localStorage.getItem("role"));
            var parameter = {
                companyId: role.company_id,
                cardholderName: this.ACreditCard.name,
                bankName: this.ACreditCard.Bank,
                bankNumber: this.ACreditCard.Cardnumber,
                billDate: this.ACreditCard.bill,
                repaymentDate: this.ACreditCard.repayment,
                expirationDate: this.ACreditCard.Effective
            };
            ajaxPost(
                Baseurl + "creditCardController/insertCreditCardInfo",
                parameter
            ).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "添加信用卡成功!"
                    });
                    this.$emit("refresh");
                } else {
                    this.$message.error("添加信用卡失败");
                }
                this.dialogTableVisible = false;
                this.ACreditCard.name = "";
                this.ACreditCard.Bank = "";
                this.ACreditCard.Cardnumber = "";
                this.ACreditCard.bill = "";
                this.ACreditCard.repayment = "";
                this.ACreditCard.Effective = "";
            });
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-dialog__body {
        padding: 13px 20px;
    }
}
.line-height {
    line-height: 30px;
}
.padding {
    padding: 5px 0;
}
</style>